import { useEffect, useState } from "react";

import type { NgwWebmapItem } from "@nextgis/ngw-kit";

import type { LegendSymbol } from "../types";

export function useLayerLegendSymbols(layer: NgwWebmapItem, enabled: boolean) {
  const [symbols, setSymbols] = useState<LegendSymbol[] | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let cancelled = false;

    Promise.resolve()
      .then(() => {
        setSymbols(null);
        return layer.getLegend();
      })
      .then((legends: { legend?: LegendSymbol[] }[]) => {
        if (cancelled) return;

        setSymbols(legends.flatMap((legend) => legend.legend || []));
      })
      .catch(() => {
        if (!cancelled) {
          setSymbols([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, layer]);

  return enabled ? symbols : null;
}
